const config = {
    development: {
        // Cuando el frontend se expone temporalmente con ngrok, las llamadas a la
        // API pasan por el proxy local de CRA para evitar certificados locales y CORS.
        apiBaseURL: window.location.hostname.endsWith("ngrok-free.dev")
            ? window.location.origin
            : (process.env.REACT_APP_API_BASE_URL || "https://localhost:7159")
    },
    production: {
        apiBaseURL: `${window.location.protocol}//${window.location.host}` // URL de produccion
    }
};

export const getConfig = () => {
    const env = process.env.REACT_APP_ENV || "development"; // Usa "development" si no se define
    return config[env];
};
